module.exports = __webpack_public_path__ + "5f831e47acb96985d8a8f7dea0065715.svg";